// HACK: hard coded values related to the x-axis because we are hard-coding the chart
// to only show a max of **five data points** equally spaced, regardless of when the score
// is actually associated with.
export const MIN_X_AXIS = 0.5;
export const MAX_X_AXIS = 5.5;
export const THRESHOLD_X_VALUES = [0, 2.3, 3.7, 6];
export const NUM_DATA_POINTS = 5;
